// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ContentSection from "common/src/ContentSection.bs.js";

function InfoContentSection(Props) {
  var mwOpt = Props.mw;
  var topTabs = Props.topTabs;
  var children = Props.children;
  var noPadding = Props.noPadding;
  var mw = mwOpt !== undefined ? mwOpt : 1072;
  var tmp = {
    className: CssJs.merge([
          "mx-auto",
          CssJs.style([T.md_([CssJs.maxWidth(CssJs.px(mw))])])
        ]),
    children: children
  };
  if (noPadding !== undefined) {
    tmp.noPadding = Caml_option.valFromOption(noPadding);
  }
  return React.createElement(AdLayout.make, {
              children: null
            }, Belt_Option.getWithDefault(topTabs, null), React.createElement(ContentSection.make, tmp));
}

var make = InfoContentSection;

export {
  make ,
  
}
/* T Not a pure module */
